import { Route, Routes } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AgentInfoProvider, useAgentInfo } from "./_context/AgentInfoContext";
import Sidebar from "./_components/Sidebar";
import KnowledgeBase from "views/agent/collection/info-agent/knowledge-base/KnowledgeBase";
import Settings from "views/agent/collection/info-agent/settings";
import MainPage from "views/agent/collection/info-agent/main/MainPage";
import AgentACLLayout from "./agent-acl";
import InfoLayout from "components/InfoLayout";
import AgentEvaluateLayout from "./agent-evaluate";
import Workflows from "views/agent/collection/info-agent/workflows/Workflows";
import AgentIntegrations from "views/agent/collection/info-agent/integrations/Integrations";
import AssignedSpecialists from "views/agent/collection/info-agent/assigned-specialists/AssignedSpecialists";
import Suggestions from "views/agent/collection/info-agent/suggestions/Suggestions";
import Trigger from "views/agent/collection/info-agent/trigger/Trigger";
import Pipeline from "views/agent/collection/info-agent/pipeline/Pipeline";
import Logs from "views/agent/collection/info-agent/logs/Logs";

const LogsWrapper = () => {
  const { logsReloadKey } = useAgentInfo();
  return <Logs key={logsReloadKey} />;
};

const getAgentHeaderKey = (location: Location): string => {
  const match = location.pathname.match(/\/info\/[^/]+(\/[^/]*)?/);
  const pathAfterInfo = match && match[1] ? match[1] : "/";
  return pathAfterInfo === "/" ? "/" : pathAfterInfo;
};

const AgentInfo = () => {
  const { t } = useTranslation();

  const HEADER_MAP = useMemo(
    () => ({
      "/": {
        title: t("agents.headers.agentInformation.title"),
        subtitle: t("agents.headers.agentInformation.subtitle"),
      },
      "/knowledge-base": {
        title: t("agents.headers.knowledgeBase.title"),
        subtitle: t("agents.headers.knowledgeBase.subtitle"),
      },
      "/settings": {
        title: t("agents.headers.agentSettings.title"),
        subtitle: t("agents.headers.agentSettings.subtitle"),
      },
      "/acl": {
        title: t("agents.headers.accessControl.title"),
        subtitle: t("agents.headers.accessControl.subtitle"),
      },
      "/evaluate": {
        title: t("agents.headers.evaluateModel.title"),
        subtitle: t("agents.headers.evaluateModel.subtitle"),
      },
      "/workflows": {
        title: t("agents.headers.workflows.title"),
        subtitle: t("agents.headers.workflows.subtitle"),
      },
      "/integrations": {
        title: t("agents.headers.integrations.title"),
        subtitle: t("agents.headers.integrations.subtitle"),
      },
      "/assigned-specialists": {
        title: t("agents.assignedSpecialists.title"),
        subtitle: t("agents.assignedSpecialists.subtitle"),
      },
      "/suggestions": {
        title: t("agents.headers.suggestions.title"),
        subtitle: t("agents.headers.suggestions.subtitle"),
      },
      "/trigger": {
        title: t("agents.headers.trigger.title"),
        subtitle: t("agents.headers.trigger.subtitle"),
      },
      "/pipeline": {
        title: t("agents.headers.pipeline.title"),
        subtitle: t("agents.headers.pipeline.subtitle"),
      },
      "/logs": {
        title: t("agents.headers.logs.title"),
        subtitle: t("agents.headers.logs.subtitle"),
      },
    }),
    [t]
  );

  return (
    <InfoLayout
      Provider={AgentInfoProvider}
      Sidebar={Sidebar}
      headerMap={HEADER_MAP}
      getHeaderKey={getAgentHeaderKey}
    >
      <div className="flex-1 p-4">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
          <Route path="/workflows" element={<Workflows />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/evaluate/*" element={<AgentEvaluateLayout />} />
          <Route path="/acl/*" element={<AgentACLLayout />} />
          <Route path="/integrations" element={<AgentIntegrations />} />
          <Route
            path="/assigned-specialists"
            element={<AssignedSpecialists />}
          />
          <Route
            path="/suggestions"
            element={
              // <PermissionRoute permission={PERMISSIONS.VIEW_SUGGESTIONS}>
              <Suggestions />
              // </PermissionRoute>
            }
          />
          <Route path="/trigger" element={<Trigger />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/logs" element={<LogsWrapper />} />
        </Routes>
      </div>
    </InfoLayout>
  );
};

export default AgentInfo;
